import React from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import TabsComponent from "../Component/Tabs/Tabs";
import LandingComponent from "../Component/LandingPage/Landing";
import LoginComponent from "../Component/Login/LoginComp/Login";
import ForgotComp from "../Component/Login/Forgotpw/Forgot";
import ConfirmAccComp from "../Component/Login/ConfirmAccount/Confirmacc";
import SetpwComponent from "../Component/Login/Setnewpw/Setpw";
import CodeverifyComp from "../Component/Login/Codeverified/Codeverify";
import PasswordsuccessComp from "../Component/Login/Passwordsuccess/Pwsuccess";
import SignuponeComp from "../Component/SignupFlow/Signupone/Signupone";
import SignuptwoComp from "../Component/SignupFlow/Signuptwo/Signuptwo";
import CreatecommunityComp from "../Component/CreateCommunity/Createcommunity";
import UpdatecommunityComp from "../Component/updateCommunity/Updatecommunity";
import CommunityComp from "../Component/Admin/Community/Community";
import SuperadmincommunityComp from "../Component/SuperAdmin/Superadmincommunity/Superadmincommunity";
import SuperAdmin from "../Component/SuperAdmin/SuperAdmin";
import Admin from "../Component/Admin/Admin";
import DashboardpageComp from "../Component/Dashboard/Dashboard";
import InProgress from "../Pages/InProgress/InProgress";
import HomeOwnerAdmin from "../Component/HomeOwnerAdmin/HomeOwnerAdmin";
import HomeOwnerCommunityComp from "../Component/HomeOwnerAdmin/HomeOwnerCommunity/HomeOwnerCommunity";
import UploadDocument from "../Component/UploadDocument/UploadDocument";
import UpdateDocument from "../Component/updateDocument/UpdateDocument";
import RealtorsBrokerages from "../Pages/Realtors & Brokerages/Realtorsandbrokerages";
import ContactPageComponent from "../Pages/Contact-us Page/contact";
import HoaComponent from "../Pages/Hoa page/Hoa";
import SuperadminprofileComp from "../Component/SuperAdmin/SuperAdminProfile/Superadminprofile";
import AdminprofileComp from "../Component/Admin/Admin Profile/Adminprofile";
import ChangePassword from "../Component/changePassword/changepass";
import HomeadminprofileComp from "../Component/HomeOwnerAdmin/HomeOwnerAdminProfile/HomeOwnerAdminprofile";
import Superadminclaimcomp from "../Component/SuperAdmin/SuperadminClaim/Superadminclaim";
import UpdateProfile from "../Component/updateProfile/updateProfile";
import EmailVerificationComp from "../Component/SignupFlow/Email-verification/EmailVerify";
import EmailVerifiedComp from "../Component/SignupFlow/EmailVerified/EmailVerified";
import SignupSuccess from "../Component/SignupFlow/SignupSuccessful/Signupsuccess";
import Chatbot from "../Component/Chatbot/Chatbot";
import RegisteredEmailVerification from "../Component/Login/RegiteredEmailVerifcation/RegisteredEmailVerification";
import Terms from "../Pages/Terms&Services/Terms";
import Privacy from "../Pages/Privacy Policy/Privacy";
import ComplianceResource from "../Pages/Compliance&Resources/ComplianceResources";
import Payment from "../Component/Billing Pages/Payments/Payment";
import Reports from "../Component/Billing Pages/Reports/Reports";
import SubscriptionPlans from "../Component/Billing Pages/Subscription Plans/Subscriptionplan";
import PaymentSuccess from "../Component/Billing Pages/PaymentSuccessPage/PaymentSuccess";
import ActiveSubscriptions from "../Component/Billing Pages/ActiveSubscriptions/ActiveSubscriptions";
import History from "../Component/Billing Pages/History/History";
import RealtorsComp from "../Component/RealtorsManagement/Realtors";
import Webcard from "../Component/RealtorsManagement/Webcard/Webcard";
import ServiceProvider from "../Component/RealtorsManagement/ServiceProvider/ServiceProvider";
import ExpertSubscriptions from "../Component/RealtorsManagement/ExpertSubscriptions/ExpertSubscriptions";
import RealtorProfile from "../Component/RealtorsManagement/RealtorProfile/RealtorProfile";
import VendorComp from "../Component/Vendor/Vendor";
import VendorSubscription from "../Component/Vendor/Vendor Subscription/VendorSubscription";
import Vendorsads from "../Component/Vendor/Vendor-Ads/Vendorsads";
import VendorsBilling from "../Component/Vendor/Vendor-Billing/VendorBilling";
import AdBanner from "../Component/Vendor/Vendor Subscription/AdBanner/AdBanner";
import DirectoryListing from "../Component/Vendor/Vendor Subscription/DirectoryListing/DirectoryListing";
import RealtorAdBanner from "../Component/RealtorsManagement/RealtorSubscription/AdBanner/AdBanner";
import VendorProfile from "../Component/Vendor/VendorProfile/VendorProfile";
import RealtorDirectoryListing from "../Component/RealtorsManagement/RealtorSubscription/RealtorDirectoryListing/RealtorDirectoryListing";
import NotFound from "../Pages/NotFound/NotFound";
import Compliance from "../Component/Admin/Compliance/Compliance";

const AppRoutes = () => {
  return (
    <BrowserRouter>
      <Routes>
        {/* <Route path="/" element={<HoaComponent />} /> */}
        <Route path="/chatbot" element={<Chatbot />} />
        <Route path="/" element={<LandingComponent />} />
        <Route path="/forgot-password" element={<ForgotComp />} />
        <Route path="/confirm-account-otp" element={<ConfirmAccComp />} />
        <Route path="/signupone" element={<SignuponeComp />} />
        <Route path="/signuptwo" element={<SignuptwoComp />} />
        <Route path="/email-verification" element={<EmailVerificationComp />} />
        <Route path="/email-verified" element={<EmailVerifiedComp />} />
        <Route path="/sign-up-success" element={<SignupSuccess />} />
        <Route path="/set-up-new-password" element={<SetpwComponent />} />
        <Route path="/code-verify" element={<CodeverifyComp />} />
        <Route path="/password-success" element={<PasswordsuccessComp />} />
        <Route path="/login" element={<LoginComponent />} />
        {/* <Route path="/tab" element={<TabsComponent />} /> */}
        <Route path="/tab/:encryptedId" element={<TabsComponent />} />
        <Route path="/Admin-community" element={<CommunityComp />} />
        <Route path="/inprogress" element={<InProgress />} />
        <Route path="/RealtorsBrokerages" element={<RealtorsBrokerages />} />
        <Route path="/Contact" element={<ContactPageComponent />} />
        <Route path="/Hoa" element={<HoaComponent />} />
        <Route path="/change-password" element={<ChangePassword />} />
        <Route
          path="/registered-email-verification"
          element={<RegisteredEmailVerification />}
        />
        <Route path="/terms-of-service" element={<Terms />} />
        <Route path="/privacy-policy" element={<Privacy />} />
        <Route
          path="/compliance-and-resources"
          element={<ComplianceResource />}
        />
        <Route path="/stripe-success" element={<PaymentSuccess />} />
        {/* <Route path="update-profile" element={<updateProfile />} /> */}
        <Route path="/super-admin" element={<SuperAdmin />}>
          <Route
            path="super-admin-community-comp"
            element={<SuperadmincommunityComp />}
          />
          <Route path="create-community" element={<CreatecommunityComp />} />
          <Route path="update-community" element={<UpdatecommunityComp />} />
          <Route path="dashboard" element={<DashboardpageComp />} />
          {/* <Route path="tab" element={<TabsComponent />} /> */}
          <Route path="dashboard" element={<DashboardpageComp />} />
          <Route path="update-document" element={<UpdateDocument />} />
          <Route path="update-profile" element={<UpdateProfile />} />
          <Route path="inprogress" element={<InProgress />} />
          <Route
            path="super-admin-profile"
            element={<SuperadminprofileComp />}
          />
          <Route path="upload-document" element={<UploadDocument />} />
          <Route path="super-admin-claim" element={<Superadminclaimcomp />} />
        </Route>

        <Route path="/admin" element={<Admin />}>
          <Route path="Admin-community" element={<CommunityComp />} />
          <Route path="create-community" element={<CreatecommunityComp />} />
          <Route path="update-community" element={<UpdatecommunityComp />} />
          <Route path="dashboard" element={<DashboardpageComp />} />
          {/* <Route path="tab" element={<TabsComponent />} /> */}
          <Route path="tab/:encryptedId" element={<TabsComponent />} />
          <Route path="upload-document" element={<UploadDocument />} />
          <Route path="update-document" element={<UpdateDocument />} />
          <Route path="update-profile" element={<UpdateProfile />} />
          <Route path="inprogress" element={<InProgress />} />
          <Route path="admin-profile" element={<AdminprofileComp />} />
          <Route path="payments" element={<Payment />} />
          <Route path="reports" element={<Reports />} />
          <Route path="subscriptions" element={<SubscriptionPlans />} />
          <Route
            path="active-subscriptions"
            element={<ActiveSubscriptions />}
          />
          <Route path="history" element={<History />} />
          <Route path="compliance" element={<Compliance />} />
        </Route>

        <Route path="/home-owner-admin" element={<HomeOwnerAdmin />}>
          <Route
            path="home-owner-community"
            element={<HomeOwnerCommunityComp />}
          />
          <Route path="create-community" element={<CreatecommunityComp />} />
          <Route path="update-community" element={<UpdatecommunityComp />} />
          <Route path="dashboard" element={<DashboardpageComp />} />
          {/* <Route path="tab" element={<TabsComponent />} /> */}
          <Route path="tab/:encryptedId" element={<TabsComponent />} />
          <Route path="homeowner-profile" element={<HomeadminprofileComp />} />
          <Route path="inprogress" element={<InProgress />} />
          <Route path="update-profile" element={<UpdateProfile />} />
        </Route>
        <Route path="/realtor" element={<RealtorsComp />}>
          <Route path="webcard" element={<Webcard />} />
          <Route path="service-provider" element={<ServiceProvider />} />
          <Route path="expert-subscription" element={<ExpertSubscriptions />} />
          <Route path="realtor-profile" element={<RealtorProfile />} />
          <Route
            path="subscription/advertisement-banner"
            element={<RealtorAdBanner />}
          />
          <Route
            path="subscription/vendor-directory-listing"
            element={<RealtorDirectoryListing />}
          />
          <Route path="update-profile" element={<UpdateProfile />} />
          <Route path="tab/:encryptedId" element={<TabsComponent />} />
        </Route>
        <Route path="/realtor/webcard/:id" element={<Webcard />} />
        <Route
          path="/tab/:encryptedId/:realtorCode"
          element={<TabsComponent />}
        />
        {/* <Route path="/realtor/webcard/placeholder" element={<InProgress />} /> */}

        {/* routes for vendors */}
        {/* <Route path="/vendor" element={<VendorComp />}/> */}
        <Route path="/vendor" element={<VendorComp />}>
          <Route path="vendor-subscription" element={<VendorSubscription />} />
          <Route path="vendor-ads" element={<Vendorsads />} />
          <Route path="vendor-billing" element={<VendorsBilling />} />
          <Route
            path="subscription/vendor-directory-listing"
            element={<DirectoryListing />}
          />
          <Route
            path="subscription/advertisement-banner"
            element={<AdBanner />}
          />
          <Route path="vendor-profile" element={<VendorProfile />} />
          <Route path="update-profile" element={<UpdateProfile />} />
        </Route>
        <Route path="*" element={<NotFound />} />
      </Routes>
    </BrowserRouter>
  );
};

export default AppRoutes;
